import { render, staticRenderFns } from "./serviceDetail.vue?vue&type=template&id=c0ff145a&scoped=true"
import script from "./serviceDetail.vue?vue&type=script&lang=js"
export * from "./serviceDetail.vue?vue&type=script&lang=js"
import style0 from "./serviceDetail.vue?vue&type=style&index=0&id=c0ff145a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ff145a",
  null
  
)

export default component.exports